module.exports = __webpack_public_path__ + "static/media/finance_use_case_1.4a7f1706.svg";